// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile__KpkBB","square":"Tile_square__Ce1_h","portrait":"Tile_portrait__L_p_g","content":"Tile_content__250OW","title":"Tile_title__faM9C","button":"Tile_button__qZFCL"};